import React from "react";
import "./fasilitas.scss";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheckDouble} from "@fortawesome/free-solid-svg-icons";
import Slider from "react-slick";

const settings1 = {
  dots: true,
  arrows: true,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
};

const Fasilitas = ({title, description, facilities, images}) => {
  // Check if the required props are available
  if (
    !title ||
    !description ||
    !facilities ||
    !Array.isArray(facilities) ||
    !images ||
    !Array.isArray(images)
  ) {
    return <div></div>;
  }

  return (
    <div className="about">
      <div id="fasilitas" className="container-fasilitas">
        <h1>{title}</h1>
        <hr />
        <div className="container-desk">
          <div className="desk">{description}</div>
        </div>
        <div className="container-benefit">
          <div className="benefit-list">
            {facilities.map((facility, index) => (
              <div className="penawaranpoin" key={index}>
                <FontAwesomeIcon
                  icon={faCheckDouble}
                  color="rgb(200, 169, 92)"
                />
                <span style={{color: "white"}}>&nbsp;&nbsp;{facility}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="slider-fasilitas">
        <Slider {...settings1}>
          {images.map((image, index) => (
            <div key={index}>
              <img src={image} alt={`Fasilitas ${index}`} />
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default Fasilitas;
